<template>
  <main id="js-page-content" role="main" class="page-content">
    <div class="row">
      <div class="subheader col-6">
        <h1 class="subheader-title">社員マスタ編集</h1>
      </div>
      <!-- Right content on content header A nice area to add graphs or buttons -->
      <div class="subheader-block ml-auto demo">
        <button
          type="button"
          @click="add()"
          v-if="!isEditMode"
          :disabled="btnDisable"
          class="btn btn-primary waves-effect waves-themed"
        >
          <span class="fal fa-check mr-1"></span>追加
        </button>
        <button
          type="button"
          @click="upd(false)"
          v-if="isEditMode"
          :disabled="btnDisable"
          class="btn btn-primary waves-effect waves-themed"
        >
          <span class="fal fa-check mr-1"></span>登録
        </button>
        <button
          type="button"
          @click="delConf()"
          v-if="isEditMode"
          :disabled="btnDisable"
          class="btn btn-danger waves-effect waves-themed"
        >
          <span class="fal fa-times mr-1"></span>削除
        </button>
        <button
          :disabled="btnDisable"
          type="button"
          class="btn btn-secondary waves-effect waves-themed"
          @click="$router.push('/employeeList')"
        >
          <span class="fal fa-reply mr-1"></span>戻る
        </button>
      </div>
    </div>
    <!-- Your main content goes below here: -->
    <div class="row">
      <div class="col-xl-12">
        <div id="panel-1" class="panel">
          <div class="panel-hdr">
            <h2>編集項目</h2>
            <div class="panel-toolbar">
              <button
                class="btn btn-panel"
                data-action="panel-collapse"
                data-toggle="tooltip"
                data-offset="0,10"
                data-original-title="Collapse"
              ></button>
              <button
                class="btn btn-panel"
                data-action="panel-fullscreen"
                data-toggle="tooltip"
                data-offset="0,10"
                data-original-title="Fullscreen"
              ></button>
            </div>
          </div>
          <div class="panel-container show" id="panel-editers">
            <div class="loader">
              <i class="fal fa-spinner-third fa-spin-4x fs-xxl"></i>
            </div>
            <div class="panel-content contents">
              <div class="row">
                <div class="col-md-1 contTitle">社員コード</div>
                <div class="col-md-5 contCnt">
                  <input
                    type="text"
                    name="txtUserCd"
                    class="form-control form-control-sm"
                    disabled
                    v-model="delegate.c_staff_id"
                  />
                </div>
              </div>
              <!-------------------->
              <div class="row">
                <div class="col-md-1 contTitle">社員番号</div>
                <div class="col-md-5 contCnt">
                  <input
                    type="text"
                    name="txtUserNumber"
                    class="form-control form-control-sm"
                    maxlength="10"
                    v-model="delegate.c_staff_number"
                  />
                </div>
              </div>
              <!-------------------->
              <div class="row">
                <div class="col-md-1 contTitle">名前</div>
                <div class="col-md-5 contCnt">
                  <input
                    type="text"
                    name="txtUserNm"
                    class="form-control form-control-sm"
                    maxlength="50"
                    v-model="delegate.c_staff_name"
                  />
                  <div
                    v-if="errors?.path === 'staffName'"
                    class="error-message4vali"
                  >
                    {{ errors.message }}
                  </div>
                </div>
              </div>
              <!-------------------->
              <div class="row">
                <div class="col-md-1 contTitle">ふりがな</div>
                <div class="col-md-5 contCnt">
                  <input
                    type="text"
                    name="txtFurigana"
                    class="form-control form-control-sm"
                    maxlength="50"
                    v-model="delegate.c_staff_name_pt"
                  />
                </div>
              </div>
              <!-------------------->
              <div class="row">
                <div class="col-md-1 contTitle">メールアドレス</div>
                <div class="col-md-5 contCnt">
                  <input
                    type="text"
                    name="txtMail_address"
                    class="form-control form-control-sm"
                    maxlength="50"
                    v-model="delegate.c_staff_mail"
                  />
                  <div
                    v-if="errors?.path === 'email'"
                    class="error-message4vali"
                  >
                    {{ errors.message }}
                  </div>
                </div>
              </div>
              <!-------------------->
              <div class="row">
                <div class="col-md-1 contTitle">拠点</div>
                <div class="col-md-5 contCnt">
                  <!-- <vSelect
                    :options="op4BranchId"
                    v-model="delegate.c_branch_id"
                    :reduce="(label:any) => label.code"
                  ></vSelect> -->
                  <vSelect
                    :options="delegate4list.items4Branch"
                    v-model="delegate.c_branch_id"
                    :reduce="(label:any) => label.c_branch_id"
                    label="c_branch_name"
                  ></vSelect>
                </div>
              </div>
              <!-------------------->
              <div class="row">
                <div class="col-md-1 contTitle">部署</div>
                <div class="col-md-5 contCnt">
                  <vSelect
                    :options="op4StaffDepart"
                    v-model="delegate.c_staff_depart"
                    :reduce="(label:any) => label.code"
                  ></vSelect>
                </div>
              </div>
              <!-------------------->
              <div class="row">
                <div class="col-md-1 contTitle">ログインID</div>
                <div class="col-md-5 contCnt">
                  <input
                    type="text"
                    name="txtLogin_id"
                    class="form-control form-control-sm"
                    maxlength="50"
                    v-model="delegate.c_staff_login_id"
                  />
                  <div
                    v-if="errors?.path === 'staffLoginid'"
                    class="error-message4vali"
                  >
                    {{ errors.message }}
                  </div>
                </div>
              </div>
              <!-------------------->
              <div class="row">
                <div class="col-md-1 contTitle">パスワード</div>
                <div class="col-md-5 contCnt">
                  <input
                    type="text"
                    name="txtPassword"
                    class="form-control form-control-sm"
                    maxlength="50"
                    v-model="delegate.c_staff_login_pass"
                  />
                  <div
                    v-if="errors?.path === 'staffPassNew'"
                    class="error-message4vali"
                  >
                    {{ errors.message }}
                  </div>
                  <div
                    v-if="errors?.path === 'staffPassUpd'"
                    class="error-message4vali"
                  >
                    {{ errors.message }}
                  </div>
                  <div
                    class="col-md-22 contTitle"
                    style="color: var(--theme-fusion-50); font-size: 12px"
                  >
                    <span
                      class="icon-stack icon-stack-lg"
                      style="font-size: 14px"
                      ><i class="fal fa-info-circle"></i
                    ></span>
                    セキュリティの為、パスワードは表示されません。変更する場合のみ、変更したいパスワードを入力してください。
                  </div>
                </div>
              </div>
              <!-------------------->
              <!-- <div class="row">
                <div class="col-md-2 contTitle">上長</div>
                <div class="col-md-9 contCnt">
                  <vSelect
                    :options="delegate4list"
                    :reduce="(label:any) => label.c_staff_id"
                    label="c_staff_name"
                  ></vSelect>
                  <vSelect
                    :options="delegate4list"
                    :reduce="(label:any) => label.c_staff_id"
                    label="c_staff_name"
                  ></vSelect>
                  <vSelect
                    :options="delegate4list"
                    :reduce="(label:any) => label.c_staff_id"
                    label="c_staff_name"
                  ></vSelect>
                  <vSelect
                    :options="delegate4list"
                    :reduce="(label:any) => label.c_staff_id"
                    label="c_staff_name"
                  ></vSelect>
                  <vSelect
                    :options="delegate4list"
                    :reduce="(label:any) => label.c_staff_id"
                    label="c_staff_name"
                  ></vSelect>
                  <vSelect
                    :options="delegate4list"
                    :reduce="(label:any) => label.c_staff_id"
                    label="c_staff_name"
                  ></vSelect>
                  <vSelect
                    :options="delegate4list"
                    :reduce="(label:any) => label.c_staff_id"
                    label="c_staff_name"
                  ></vSelect>
                  <vSelect
                    :options="delegate4list"
                    :reduce="(label:any) => label.c_staff_id"
                    label="c_staff_name"
                  ></vSelect>
                  <vSelect
                    :options="delegate4list"
                    :reduce="(label:any) => label.c_staff_id"
                    label="c_staff_name"
                  ></vSelect>
                  <vSelect
                    :options="delegate4list"
                    :reduce="(label:any) => label.c_staff_id"
                    label="c_staff_name"
                  ></vSelect>
                </div>
              </div> -->
              <div class="row">
                <div class="col-md-1 contTitle">上長1</div>
                <div class="col-md-5 contCnt">
                  <div class="row">
                    <div class="col-md-12 contCnt selectedClear">
                      <vSelect
                        :options="getOpStaffs(1)"
                        v-model="delegate.c_staff_elder_user_id_1"
                        :reduce="(label:any) => label.c_staff_id"
                        label="c_staff_name"
                      ></vSelect>
                    </div>
                  </div>
                </div>
              </div>
              <!-------------------->
              <div class="row">
                <div class="col-md-1 contTitle">上長2</div>
                <div class="col-md-5 contCnt">
                  <div class="row">
                    <div class="col-md-12 contCnt selectedClear">
                      <vSelect
                        :options="getOpStaffs(2)"
                        v-model="delegate.c_staff_elder_user_id_2"
                        :reduce="(label:any) => label.c_staff_id"
                        label="c_staff_name"
                      ></vSelect>
                    </div>
                  </div>
                </div>
              </div>
              <!-------------------->
              <div class="row">
                <div class="col-md-1 contTitle">上長3</div>
                <div class="col-md-5 contCnt">
                  <div class="row">
                    <div class="col-md-12 contCnt selectedClear">
                      <vSelect
                        :options="getOpStaffs(3)"
                        v-model="delegate.c_staff_elder_user_id_3"
                        :reduce="(label:any) => label.c_staff_id"
                        label="c_staff_name"
                      ></vSelect>
                    </div>
                  </div>
                </div>
              </div>
              <!-------------------->
              <div class="row">
                <div class="col-md-1 contTitle">上長4</div>
                <div class="col-md-5 contCnt">
                  <div class="row">
                    <div class="col-md-12 contCnt selectedClear">
                      <vSelect
                        :options="getOpStaffs(4)"
                        v-model="delegate.c_staff_elder_user_id_4"
                        :reduce="(label:any) => label.c_staff_id"
                        label="c_staff_name"
                      ></vSelect>
                    </div>
                  </div>
                </div>
              </div>
              <!-------------------->
              <div class="row">
                <div class="col-md-1 contTitle">上長5</div>
                <div class="col-md-5 contCnt">
                  <div class="row">
                    <div class="col-md-12 contCnt selectedClear">
                      <vSelect
                        :options="getOpStaffs(5)"
                        v-model="delegate.c_staff_elder_user_id_5"
                        :reduce="(label:any) => label.c_staff_id"
                        label="c_staff_name"
                      ></vSelect>
                    </div>
                  </div>
                </div>
              </div>
              <!-------------------->
              <div class="row">
                <div class="col-md-1 contTitle">上長6</div>
                <div class="col-md-5 contCnt">
                  <div class="row">
                    <div class="col-md-12 contCnt selectedClear">
                      <vSelect
                        :options="getOpStaffs(6)"
                        v-model="delegate.c_staff_elder_user_id_6"
                        :reduce="(label:any) => label.c_staff_id"
                        label="c_staff_name"
                      ></vSelect>
                    </div>
                  </div>
                </div>
              </div>
              <!-------------------->
              <div class="row">
                <div class="col-md-1 contTitle">上長7</div>
                <div class="col-md-5 contCnt">
                  <div class="row">
                    <div class="col-md-12 contCnt selectedClear">
                      <vSelect
                        :options="getOpStaffs(7)"
                        v-model="delegate.c_staff_elder_user_id_7"
                        :reduce="(label:any) => label.c_staff_id"
                        label="c_staff_name"
                      ></vSelect>
                    </div>
                  </div>
                </div>
              </div>
              <!-------------------->
              <div class="row">
                <div class="col-md-1 contTitle">上長8</div>
                <div class="col-md-5 contCnt">
                  <div class="row">
                    <div class="col-md-12 contCnt selectedClear">
                      <vSelect
                        :options="getOpStaffs(8)"
                        v-model="delegate.c_staff_elder_user_id_8"
                        :reduce="(label:any) => label.c_staff_id"
                        label="c_staff_name"
                      ></vSelect>
                    </div>
                  </div>
                </div>
              </div>
              <!-------------------->
              <div class="row">
                <div class="col-md-1 contTitle">上長9</div>
                <div class="col-md-5 contCnt">
                  <div class="row">
                    <div class="col-md-12 contCnt selectedClear">
                      <vSelect
                        :options="getOpStaffs(9)"
                        v-model="delegate.c_staff_elder_user_id_9"
                        :reduce="(label:any) => label.c_staff_id"
                        label="c_staff_name"
                      ></vSelect>
                    </div>
                  </div>
                </div>
              </div>
              <!-------------------->
              <div class="row">
                <div class="col-md-1 contTitle">上長10</div>
                <div class="col-md-5 contCnt">
                  <div class="row">
                    <div class="col-md-12 contCnt selectedClear">
                      <vSelect
                        :options="getOpStaffs(10)"
                        v-model="delegate.c_staff_elder_user_id_10"
                        :reduce="(label:any) => label.c_staff_id"
                        label="c_staff_name"
                      ></vSelect>
                    </div>
                  </div>
                </div>
              </div>
              <!-------------------->
              <div class="row">
                <div class="col-md-1 contTitle">申請承認1</div>
                <div class="col-md-5 contCnt">
                  <div class="row">
                    <div class="col-md-12 contCnt selectedClear">
                      <vSelect
                        :options="getOpStaffs(11)"
                        v-model="delegate.c_staff_application_staff_id_1"
                        :reduce="(label:any) => label.c_staff_id"
                        label="c_staff_name"
                      ></vSelect>
                    </div>
                  </div>
                </div>
              </div>
              <!-------------------->
              <div class="row">
                <div class="col-md-1 contTitle">申請承認2</div>
                <div class="col-md-5 contCnt">
                  <div class="row">
                    <div class="col-md-12 contCnt selectedClear">
                      <vSelect
                        :options="getOpStaffs(12)"
                        v-model="delegate.c_staff_application_staff_id_2"
                        :reduce="(label:any) => label.c_staff_id"
                        label="c_staff_name"
                      ></vSelect>
                    </div>
                  </div>
                </div>
              </div>
              <!-------------------->
              <div class="row">
                <div class="col-md-1 contTitle">申請承認3</div>
                <div class="col-md-5 contCnt">
                  <div class="row">
                    <div class="col-md-12 contCnt selectedClear">
                      <vSelect
                        :options="getOpStaffs(13)"
                        v-model="delegate.c_staff_application_staff_id_3"
                        :reduce="(label:any) => label.c_staff_id"
                        label="c_staff_name"
                      ></vSelect>
                    </div>
                  </div>
                </div>
              </div>
              <!-------------------->
              <div class="row">
                <div class="col-md-1 contTitle">個人承認1</div>
                <div class="col-md-5 contCnt">
                  <div class="row">
                    <div class="col-md-12 contCnt selectedClear">
                      <vSelect
                        :options="getOpStaffs(14)"
                        v-model="delegate.c_staff_individual_staff_id_1"
                        :reduce="(label:any) => label.c_staff_id"
                        label="c_staff_name"
                      ></vSelect>
                    </div>
                  </div>
                </div>
              </div>
              <!-------------------->
              <div class="row">
                <div class="col-md-1 contTitle">個人承認2</div>
                <div class="col-md-5 contCnt">
                  <div class="row">
                    <div class="col-md-12 contCnt selectedClear">
                      <vSelect
                        :options="getOpStaffs(15)"
                        v-model="delegate.c_staff_individual_staff_id_2"
                        :reduce="(label:any) => label.c_staff_id"
                        label="c_staff_name"
                      ></vSelect>
                    </div>
                  </div>
                </div>
              </div>
              <!-------------------->
              <div class="row">
                <div class="col-md-1 contTitle">個人承認3</div>
                <div class="col-md-5 contCnt">
                  <div class="row">
                    <div class="col-md-12 contCnt selectedClear">
                      <vSelect
                        :options="getOpStaffs(16)"
                        v-model="delegate.c_staff_individual_staff_id_3"
                        :reduce="(label:any) => label.c_staff_id"
                        label="c_staff_name"
                      ></vSelect>
                    </div>
                  </div>
                </div>
              </div>
              <!-------------------->
              <div class="row">
                <div class="col-md-1 contTitle">システム権限</div>
                <div class="col-md-5 contCnt">
                  <vSelect
                    :options="op4AuthType"
                    v-model="delegate.c_staff_auth_type"
                    :reduce="(label:any) => label.code"
                  ></vSelect>
                </div>
              </div>
              <!-------------------->
              <div class="row">
                <div class="col-md-1 contTitle">請求書印刷担当拠点</div>
                <div class="col-md-5 contCnt">
                  <vSelect
                    multiple
                    :options="delegate4list.items4Branch"
                    v-model="domStaffBillingPerson"
                    :reduce="(label:any) => label.c_branch_id"
                    label="c_branch_name"
                  ></vSelect>
                </div>
              </div>
              <!-------------------->
              <div class="row">
                <div class="col-md-1 contTitle">表示</div>
                <div class="col-md-5 contCnt">
                  <vSelect
                    :options="op4ShowOrder"
                    v-model="delegate.c_staff_flag_show"
                    :reduce="(label:any) => label.code"
                  ></vSelect>
                </div>
              </div>
              <!-------------------->
              <div class="row">
                <div class="col-md-1 contTitle">勤怠機能用表示順</div>
                <div class="col-md-5 contCnt">
                  <!-- <vSelect
                    :options="op4ShowOrderAttendance"
                    v-model="delegate.c_staff_show_order_attendandce"
                    :reduce="(label:any) => label.code"
                  ></vSelect> -->
                  <input
                    type="number"
                    name="txtshow_order_attendandce"
                    class="form-control form-control-sm"
                    maxlength="200"
                    v-model="delegate.c_staff_show_order_attendandce"
                  />
                </div>
              </div>
              <!-------------------->
            </div>
            <!-------------------->
            <div
              class="panel-content contents border-faded border-left-0 border-right-0 border-down-0"
            >
              <div class="row md-3">
                <div class="col-auto contTitle font-weight-bold">
                  メール配信設定
                </div>
              </div>
              <!-------------------->
              <span class="spacer"></span>
              <div class="row">
                <div class="col-md-1 contTitle">　配信先アドレス</div>
                <div class="col-md-5 contCnt">
                  <input
                    type="text"
                    name="txtMail_alert"
                    class="form-control form-control-sm"
                    v-model="delegate.c_staff_alert_mail"
                  />
                  <div
                    v-if="errors?.path === 'email'"
                    class="error-message4vali"
                  >
                    {{ errors.message }}
                  </div>
                  <span style="color: red"
                    >カンマ（,）区切りで複数アドレス対応可能です。</span
                  >
                </div>
              </div>
              <!-------------------->
              <span class="spacer"></span>
              <div class="row">
                <div class="col-md-1 contTitle">　配信対象アラート</div>
                <div class="col-md-5 contCnt">
                  <div class="custom-control custom-checkbox">
                    <input
                      type="checkbox"
                      id="ckClaimreq"
                      class="custom-control-input"
                      v-bind:checked="(delegate.c_staff_flag_mail_claim_request as any)"
                      @change="
                        delegate.c_staff_flag_mail_claim_request = cnvCb($event)
                      "
                    />
                    <label class="custom-control-label" for="ckClaimreq"
                      >請求書承認依頼通知</label
                    >
                  </div>
                  <div class="custom-control custom-checkbox">
                    <input
                      type="checkbox"
                      id="ckClaimok"
                      class="custom-control-input"
                      v-bind:checked="(delegate.c_staff_flag_mail_claim_approval as any)"
                      @change="
                        delegate.c_staff_flag_mail_claim_approval =
                          cnvCb($event)
                      "
                    />
                    <label class="custom-control-label" for="ckClaimok"
                      >請求書承認通知</label
                    >
                  </div>
                  <div class="custom-control custom-checkbox">
                    <input
                      type="checkbox"
                      id="ckClaimnot"
                      class="custom-control-input"
                      v-bind:checked="(delegate.c_staff_flag_mail_claim_return as any)"
                      @change="
                        delegate.c_staff_flag_mail_claim_return = cnvCb($event)
                      "
                    />
                    <label class="custom-control-label" for="ckClaimnot"
                      >請求書差し戻し通知</label
                    >
                  </div>
                  <span class="spacer"></span>
                  <div class="custom-control custom-checkbox">
                    <input
                      type="checkbox"
                      id="ckPeriodsale"
                      class="custom-control-input"
                      v-bind:checked="(delegate.c_staff_flag_mail_contract_period_sales as any)"
                      @change="
                        delegate.c_staff_flag_mail_contract_period_sales =
                          cnvCb($event)
                      "
                    />
                    <label class="custom-control-label" for="ckPeriodsale"
                      >販売契約期間満期接近通知</label
                    >
                  </div>
                  <div class="custom-control custom-checkbox">
                    <input
                      type="checkbox"
                      id="ckPeriodsupply"
                      class="custom-control-input"
                      v-bind:checked="(delegate.c_staff_flag_mail_contract_period_supply as any)"
                      @change="
                        delegate.c_staff_flag_mail_contract_period_supply =
                          cnvCb($event)
                      "
                    />
                    <label class="custom-control-label" for="ckPeriodsupply"
                      >仕入契約期間満期接近通知</label
                    >
                  </div>
                  <span class="spacer"></span>
                  <div class="custom-control custom-checkbox">
                    <input
                      type="checkbox"
                      id="ckReqreqest"
                      class="custom-control-input"
                      v-bind:checked="(delegate.c_staff_flag_mail_request_request as any)"
                      @change="
                        delegate.c_staff_flag_mail_request_request =
                          cnvCb($event)
                      "
                    />
                    <label class="custom-control-label" for="ckReqreqest"
                      >申請書承認依頼通知</label
                    >
                  </div>
                  <div class="custom-control custom-checkbox">
                    <input
                      type="checkbox"
                      id="ckReqok"
                      class="custom-control-input"
                      v-bind:checked="(delegate.c_staff_flag_mail_request_approval as any)"
                      @change="
                        delegate.c_staff_flag_mail_request_approval =
                          cnvCb($event)
                      "
                    />
                    <label class="custom-control-label" for="ckReqok"
                      >申請書承認通知</label
                    >
                  </div>
                  <div class="custom-control custom-checkbox">
                    <input
                      type="checkbox"
                      id="ckReqnot"
                      class="custom-control-input"
                      v-bind:checked="(delegate.c_staff_flag_mail_request_return as any)"
                      @change="
                        delegate.c_staff_flag_mail_request_return =
                          cnvCb($event)
                      "
                    />
                    <label class="custom-control-label" for="ckReqnot"
                      >申請書差戻通知</label
                    >
                  </div>
                  <div class="custom-control custom-checkbox">
                    <input
                      type="checkbox"
                      id="ckReqdown"
                      class="custom-control-input"
                      v-bind:checked="(delegate.c_staff_flag_mail_request_withdrawal as any)"
                      @change="
                        delegate.c_staff_flag_mail_request_withdrawal =
                          cnvCb($event)
                      "
                    />
                    <label class="custom-control-label" for="ckReqdown"
                      >申請書取下通知</label
                    >
                  </div>
                </div>
              </div>
              <!-------------------->
            </div>
            <!-------------------->
          </div>
        </div>
      </div>
    </div>

    <!-- 成功通知モーダル -->
    <Mo_modal_alert ref="Mo_modal_success" @modalclosed="get()">
      <template v-slot:title>
        <i class="fal fa-check-circle text-success mr-2"></i>
        <span class="text-success fw-500">{{ message4ModalSuccess }}</span>
      </template>
      <template v-slot:body><br /></template>
      <template v-slot:footer>
        <div class="modal-footer"><br /></div>
      </template>
    </Mo_modal_alert>
    <!-- 成功通知モーダル -->
    <!-- 削除確認モーダル -->
    <Mo_modal_alert ref="Mo_modal_deleteConf">
      <template v-slot:title>
        <i class="fal fa-times-circle text-danger mr-2"></i
        >{{ message4ModalDelConf }}
      </template>
      <template v-slot:body><br /></template>
      <template v-slot:footer>
        <div class="modal-footer">
          <button
            @click="del()"
            type="button"
            class="btn btn-danger shadow-0 bootbox-accept"
          >
            はい</button
          ><button
            @click="closeModal4deleteConf()"
            type="button"
            class="btn btn-default bootbox-cancel"
          >
            いいえ
          </button>
        </div>
      </template>
    </Mo_modal_alert>
    <!-- 削除確認モーダル -->
    <!-- エラー確認モーダル -->
    <Mo_modal_alert ref="Mo_modal_errorConf">
      <template v-slot:title>
        <i class="fal fa-times-circle text-danger mr-2"></i
        >{{ message4ModalErrorConf }}
      </template>
      <template v-slot:body><br /></template>
      <template v-slot:footer>
        <div class="modal-footer">
          <button
            @click="closeModal4ErrorConf()"
            type="button"
            class="btn btn-default bootbox-cancel"
          >
            確認
          </button>
        </div>
      </template>
    </Mo_modal_alert>
    <!-- エラー確認モーダル -->
  </main>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import Mo_modal_alert from "@/components/molecules/Mo_modal_alert.vue";

// バリデーション
import * as Yup from "yup";
import { DtoStaffsGetResImple } from "furukawa-common/src/common/dto/DtoStaffsGetResImple";
import { DtoMastersGetRes } from "furukawa-common/src/common/dto/DtoMastersGetRes";
import { DtoMastersgetReq } from "furukawa-common/src/common/dto/DtoMastersGetReq";
import { Cl_common } from "@/functions/Cl_common";
import { Cl_staff } from "@/functions/Cl_staff";
import { Cl_master } from "@/functions/Cl_master";
import { DtoStaffsPostReq } from "furukawa-common/src/common/dto/abst/DtoStaffsPostReq";
import { DtoStaffsPutReq } from "furukawa-common/src/common/dto/abst/DtoStaffsPutReq";
import { DtoStaffsGetReqImple } from "furukawa-common/src/common/dto/DtoStaffsGetReqImple";
import {
  CONST_OP_AUTHTYPE,
  CONST_OP_SHOWORDER,
  CONST_OP_STAFFDEPART,
} from "furukawa-common/src/common/constant/Constants";
import { EntityStaff } from "../../../furukawa-common/src/common/entity/EntityStaff";

@Options({
  components: {
    Mo_modal_alert,
    vSelect,
  },
})
export default class EmployeeEdit extends Vue {
  //----------------------
  //バリデーション
  //----------------------
  //スキーマ宣言
  schemaAdd = Yup.object().shape({
    staffName: Yup.string().required("社員名を入力してください"),
    staffLoginid: Yup.string()
      .required("ログインIDを入力してください")
      .matches(
        /^[0-9a-zA-Z.]{4,}$/,
        "ログインIDは半角英数およびドット（.）4桁以上で入力してください。"
      ),
    staffPassNew: Yup.string()
      .required("パスワードを入力してください")
      .matches(
        /^[0-9a-zA-Z]{6,}$/,
        "パスワードは半角英数6桁以上で入力してください。"
      ),
    email: Yup.string()
      .email("有効なメールアドレスを入力してください")
      .required("メールアドレスを入力してください"),
  });
  schemaUpd = Yup.object().shape({
    staffName: Yup.string().required("社員名を入力してください"),
    staffLoginid: Yup.string()
      .required("ログインIDを入力してください")
      .matches(
        /^[0-9a-zA-Z.]{4,}$/,
        "ログインIDは半角英数およびドット（.）4桁以上で入力してください。"
      ),
    staffPassUpd: Yup.string()
      .nullable()
      .matches(
        /^([0-9a-zA-Z]{6,}|)$/,
        "パスワードは半角英数6桁以上で入力してください。"
      ),
    email: Yup.string()
      .email("有効なメールアドレスを入力してください")
      .required("メールアドレスを入力してください"),
  });

  //エラー格納用
  errors: Yup.ValidationError | null = null;

  //----------------------
  //DOM連携用プロパティ
  //----------------------
  delegate = new DtoStaffsGetResImple();
  delegate4list = new DtoMastersGetRes();
  btnDisable = false;
  isEditMode = true;
  domStaffBillingPerson: number[] = [];

  //----------------------
  //セレクトボックス用プロパティ
  //----------------------
  op4StaffDepart = CONST_OP_STAFFDEPART;
  op4AuthType = CONST_OP_AUTHTYPE;
  op4ShowOrder = CONST_OP_SHOWORDER;
  op4ShowOrderAttendance = CONST_OP_SHOWORDER;
  /**
   * 社員の選択肢を構築する用
   */
  getOpStaffs(No: number): EntityStaff[] | undefined {
    switch (No) {
      case 1:
        return this.delegate4list.getStaffSortNum4NoneDelete([
          this.delegate.c_staff_elder_user_id_1!,
        ]);
      case 2:
        return this.delegate4list.getStaffSortNum4NoneDelete([
          this.delegate.c_staff_elder_user_id_2!,
        ]);
      case 3:
        return this.delegate4list.getStaffSortNum4NoneDelete([
          this.delegate.c_staff_elder_user_id_3!,
        ]);
      case 4:
        return this.delegate4list.getStaffSortNum4NoneDelete([
          this.delegate.c_staff_elder_user_id_4!,
        ]);
      case 5:
        return this.delegate4list.getStaffSortNum4NoneDelete([
          this.delegate.c_staff_elder_user_id_5!,
        ]);
      case 6:
        return this.delegate4list.getStaffSortNum4NoneDelete([
          this.delegate.c_staff_elder_user_id_6!,
        ]);
      case 7:
        return this.delegate4list.getStaffSortNum4NoneDelete([
          this.delegate.c_staff_elder_user_id_7!,
        ]);
      case 8:
        return this.delegate4list.getStaffSortNum4NoneDelete([
          this.delegate.c_staff_elder_user_id_8!,
        ]);
      case 9:
        return this.delegate4list.getStaffSortNum4NoneDelete([
          this.delegate.c_staff_elder_user_id_9!,
        ]);
      case 10:
        return this.delegate4list.getStaffSortNum4NoneDelete([
          this.delegate.c_staff_elder_user_id_10!,
        ]);
      case 11:
        return this.delegate4list.getStaffSortNum4NoneDelete([
          this.delegate.c_staff_application_staff_id_1!,
        ]);
      case 12:
        return this.delegate4list.getStaffSortNum4NoneDelete([
          this.delegate.c_staff_application_staff_id_2!,
        ]);
      case 13:
        return this.delegate4list.getStaffSortNum4NoneDelete([
          this.delegate.c_staff_application_staff_id_3!,
        ]);
      case 14:
        return this.delegate4list.getStaffSortNum4NoneDelete([
          this.delegate.c_staff_individual_staff_id_1!,
        ]);
      case 15:
        return this.delegate4list.getStaffSortNum4NoneDelete([
          this.delegate.c_staff_individual_staff_id_2!,
        ]);
      case 16:
        return this.delegate4list.getStaffSortNum4NoneDelete([
          this.delegate.c_staff_individual_staff_id_3!,
        ]);
    }
  }
  //----------------------
  //モーダル用プロパティ
  //----------------------
  message4ModalSuccess = "";
  message4ModalDelConf = "";
  message4ModalErrorConf = "";

  //----------------------
  //制御用メソッド
  //----------------------
  async mounted() {
    await this.getMastersList();
    await this.get();
  }

  //----------------------
  //基本操作用メソッド
  //----------------------
  /**
   *Masters取得用
   */
  async getMastersList() {
    //ボタン無効＋ローダー表示
    //-----------------
    this.btnDisable = true;
    const panel = document.getElementsByClassName("panel-container");
    Array.from(panel).map((element: Element) => {
      element.classList.add("enable-loader");
    });

    try {
      //処理
      //-----------------
      Cl_common.logger("処理実行社員マスタ取得");

      //準備
      //-------
      let dtoMaster = new DtoMastersgetReq();

      dtoMaster.getStaff4sortNum = 1;
      dtoMaster.delFlag4Staff4sortNum = 0;

      // dtoMaster.getStaff = 1;
      // dtoMaster.delFlag4staff = 0;

      dtoMaster.getBranch = 1;
      dtoMaster.delFlag4Branch = 0;

      //API実行
      //-------
      this.delegate4list = await Cl_master.get(dtoMaster);
      console.log("this.delegate4list");
      console.log(this.delegate4list);

      //レスポンス処理
      //-------
    } catch (error) {
      //モーダルのメッセージを設定
      this.message4ModalErrorConf = "エラーが発生しました"; //モーダル表示
      const modal: any = this.$refs.Mo_modal_errorConf;
      modal.showModal();

      this.delegate4list = new DtoMastersGetRes();
      Cl_common.logger(error);
    } finally {
      //ボタン無効解除＋ローダー非表示
      //-----------------
      this.btnDisable = false;
      Array.from(panel).map((element: Element) => {
        element.classList.remove("enable-loader");
      });
    }
  }

  /**
   * チェックボックスの値を数値に変換する
   * @param event
   */
  cnvCb(event: any): number {
    if (event.target.checked) {
      return 1;
    } else {
      return 0;
    }
  }

  /**
   * データを読み込む
   */
  async get() {
    //ボタン無効＋ローダー表示
    //-----------------
    this.btnDisable = true;
    const panel = document.getElementsByClassName("panel-container");
    Array.from(panel).map((element: Element) => {
      element.classList.add("enable-loader");
    });

    try {
      //処理
      //-----------------
      Cl_common.logger("処理実行");

      //パラメータにIDが指定されていなければ、新規追加モードでデータを読み込まない
      //-------
      let id = Cl_common.getParam("id");
      if (id == "") {
        //新規追加
        this.isEditMode = false;
        //初期値設定
        this.delegate.c_staff_depart = 1;
        this.delegate.c_branch_id = 1;
        this.delegate.c_staff_show_order = 1;
        this.delegate.c_staff_auth_type = 1;
        // this.delegate.c_staff_flag_auth_claim = 1;
        this.delegate.c_staff_flag_del = 0;
        return;
      } else {
        //編集
        this.isEditMode = true;
      }

      //準備
      //-------
      let dto = new DtoStaffsGetReqImple();

      dto.c_staff_id = Number(id);

      //API実行
      //-------
      this.delegate = await Cl_staff.get(dto);
      console.log(this.delegate);
      //レスポンス処理
      //-------
      //IDがnullなら一覧へ遷移
      if (this.delegate.c_staff_id == null) {
        this.$router.push("/employeeList");
      }
      //請求書印刷担当拠点用変換
      if (
        null != this.delegate.c_staff_billing_person &&
        "" != this.delegate.c_staff_billing_person
      ) {
        this.domStaffBillingPerson = await this.cnvStrArray2NumArray(
          this.delegate.c_staff_billing_person!.split(",")
        );
      }
    } catch (error) {
      //モーダルのメッセージを設定
      this.message4ModalErrorConf = "エラーが発生しました";
      //モーダル表示
      const modal: any = this.$refs.Mo_modal_errorConf;
      modal.showModal();

      Cl_common.logger(error);
    } finally {
      //ボタン無効解除＋ローダー非表示
      //-----------------
      this.btnDisable = false;
      Array.from(panel).map((element: Element) => {
        element.classList.remove("enable-loader");
      });
    }
  }

  /**
   * データを更新する
   */
  async upd(isDel: boolean) {
    //ボタン無効＋ローダー表示
    //-----------------
    this.btnDisable = true;
    const panel = document.getElementsByClassName("panel-container");
    Array.from(panel).map((element: Element) => {
      element.classList.add("enable-loader");
    });

    try {
      //処理
      //-----------------
      Cl_common.logger("処理実行");

      //準備
      //-------
      let dto = new DtoStaffsPutReq();
      if (isDel) {
        //削除処理：削除フラグを立てる。
        dto.c_staff_id = this.delegate.c_staff_id;
        dto.c_staff_flag_del = 1;
      } else {
        //バリデーション
        //-----------------
        this.errors = null;
        this.schemaUpd.validateSync({
          staffName: this.delegate.c_staff_name,
          email: this.delegate.c_staff_mail,
          staffLoginid: this.delegate.c_staff_login_id,
          staffPassUpd: this.delegate.c_staff_login_pass,
        });

        //請求書印刷担当拠点用変換
        if (undefined != this.domStaffBillingPerson) {
          this.delegate.c_staff_billing_person =
            this.domStaffBillingPerson.join(",");
        }
        //更新処理：delegateからdtoにデータ投入。
        dto = Object.assign(new DtoStaffsPutReq(), this.delegate);
      }

      //API実行
      //-------
      await Cl_staff.put(dto);
      //レスポンスの処理
      //-------

      //更新処理：
      //モーダルのメッセージを設定
      if (isDel) {
        //削除処理：
        this.message4ModalSuccess = "データを削除しました。";
      } else {
        //更新処理：
        this.message4ModalSuccess = "データを更新しました。";
      }

      //モーダルを表示
      const modal: any = this.$refs.Mo_modal_success;
      modal.showModal();
    } catch (error) {
      if (error instanceof Yup.ValidationError) {
        //バリデーション
        //---------------
        //モーダルのメッセージを設定
        this.message4ModalErrorConf = error.errors[0];
        this.errors = error;
      } else {
        //それ以外
        //---------------
        //モーダルのメッセージを設定
        this.message4ModalErrorConf = "エラーが発生しました";
      }
      //モーダル表示
      const modal: any = this.$refs.Mo_modal_errorConf;
      modal.showModal();

      Cl_common.logger(error);
    } finally {
      //ボタン無効解除＋ローダー非表示
      //-----------------
      this.btnDisable = false;
      Array.from(panel).map((element: Element) => {
        element.classList.remove("enable-loader");
      });
    }
  }

  /**
   * データを新たに登録する
   */
  async add() {
    //ボタン無効＋ローダー表示
    //-----------------
    this.btnDisable = true;
    const panel = document.getElementsByClassName("panel-container");
    Array.from(panel).map((element: Element) => {
      element.classList.add("enable-loader");
    });

    try {
      //処理
      //-----------------
      Cl_common.logger("処理実行");

      //バリデーション
      //-----------------
      this.errors = null;
      this.schemaAdd.validateSync({
        staffName: this.delegate.c_staff_name,
        email: this.delegate.c_staff_mail,
        staffLoginid: this.delegate.c_staff_login_id,
        staffPassNew: this.delegate.c_staff_login_pass,
      });

      //準備
      //-------
      //請求書印刷担当拠点用変換
      if (undefined != this.domStaffBillingPerson) {
        this.delegate.c_staff_billing_person =
          this.domStaffBillingPerson.join(",");
      }
      let dto = Object.assign(new DtoStaffsPostReq(), this.delegate);
      dto.c_staff_flag_del = 0;

      //API実行
      //-------
      const res = await Cl_staff.post(dto);

      //レスポンスの処理
      //-------
      //編集画面のURL作成
      this.$router.push({
        path: "/employeeEdit",
        query: { id: res.c_staff_id },
      });

      //this.start = res.c_message_start?.toString().split("T")[0];
      //this.end = res.c_message_end?.toString().split("T")[0];

      //モーダルのメッセージを設定
      this.message4ModalSuccess = "正常に追加されました";

      //モーダルを表示
      const modal: any = this.$refs.Mo_modal_success;
      modal.showModal();
    } catch (error) {
      if (error instanceof Yup.ValidationError) {
        //バリデーション
        //---------------
        //モーダルのメッセージを設定
        this.message4ModalErrorConf = error.errors[0];
        this.errors = error;
      } else {
        //それ以外
        //---------------
        //モーダルのメッセージを設定
        this.message4ModalErrorConf = "エラーが発生しました";
      }
      //モーダル表示
      const modal: any = this.$refs.Mo_modal_errorConf;
      modal.showModal();

      Cl_common.logger(error);
    } finally {
      //ボタン無効解除＋ローダー非表示
      //-----------------
      this.btnDisable = false;
      Array.from(panel).map((element: Element) => {
        element.classList.remove("enable-loader");
      });
    }
  }

  /**
   * データを削除する
   */
  async del() {
    //削除フラグのあるテーブルなので更新処理。
    this.closeModal4deleteConf();
    this.upd(true);
  }

  async cnvStrArray2NumArray(strArray: string[]): Promise<number[]> {
    let res: number[] = [];

    for (let i = 0; i < strArray.length; ++i) {
      res.push(Number(strArray[i]));
    }

    return res;
  }

  //----------------------
  //モーダル用メソッド
  //----------------------
  /**
   * データを削除する
   */
  async delConf() {
    //モーダルのメッセージを設定
    this.message4ModalDelConf = "削除してもよろしいでしょうか。";

    //モーダルを表示
    const modal: any = this.$refs.Mo_modal_deleteConf;
    modal.showModal();
  }

  async closeModal4deleteConf(): Promise<void> {
    const modal: any = this.$refs.Mo_modal_deleteConf;
    modal.closeModal();
  }

  async closeModal4ErrorConf(): Promise<void> {
    const modal: any = this.$refs.Mo_modal_errorConf;
    modal.closeModal();
  }
}
</script>
<style>
.spacer {
  display: inline-block;
  height: 5px; /* 隙間の高さを設定 */
}
</style>
